import type { ActionType } from "typesafe-actions";
import { getType } from "typesafe-actions";

import { actions as jupyterImagesActions } from "../jupyterImages/actions";

export type JupyterImages = string[] | null;

const INITIAL_STATE: JupyterImages = null;

export function jupyterImages(
  state: JupyterImages = INITIAL_STATE,
  action: ActionType<typeof jupyterImagesActions>,
): JupyterImages {
  switch (action.type) {
    case getType(jupyterImagesActions.getJupyterImages.success): {
      return action.payload;
    }
    default:
      return state;
  }
}
